import { RoutePaths } from "../enums";
import type { HelpTopicContentLocale } from "../models/help-topics.models";

/** Maps app i18n language to help topic content locale. */
export const mapAppLanguageToHelpTopicLocale = (
  language: string | undefined,
): HelpTopicContentLocale => {
  return language?.toLowerCase().startsWith("he") ? "he" : "en";
};

/** Folder of a topic inside its locale, e.g. `systemparams/production` — the markdown's relative image links resolve against it. */
export const resolveHelpTopicDirectory = (topicPath: string): string => {
  return topicPath.replace(/^\/+/, "").replace(/\/[^/]*$/, "");
};

export const resolveHelpTopicAppRoute = (helpTopikUrl: string): string => {
  const normalized = helpTopikUrl.replace(/^\/+/, "");
  return `${RoutePaths.HELP_TOPICS}/${normalized}`;
};

export const formatHelpTopicLabel = (topicId: string): string => {
  return topicId
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/_/g, " ")
    .replace(/\b\w/g, char => char.toUpperCase());
};
